/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import find from 'lodash/find';

import {
    CAMPSITE_CHANGE_STATUS,
    GET_CAMPSITE,
    GET_CAMPSITE_ERROR,
    GET_CAMPSITE_LIST,
    GET_CAMPSITE_LIST_ERROR,
    GET_CAMPSITES,
    GET_CAMPSITES_ERROR,
} from '../constants';

const initialState = {
    results: {},
    list: [],
};
export default function campsite(state = initialState, action) {
    const st = { ...state };

    // TODO: This is the bruteforce code in order to poulate the media collection from the attributes
    // This logic should move to the back-end.
    const getMediaFromAttributes = (attrs) =>
        attrs &&
        attrs
            .filter((el) => el.attribute_name.indexOf('media') > -1)
            .map((el) => ({
                credits: '',
                description: '',
                embedcode: '',
                height: '360',
                media_type: 'Image',
                subtitle: '',
                title: '',
                url: `https://ridb.recreation.gov/images/${el.attribute_value}`,
                width: '540',
            }));

    switch (action.type) {
        case GET_CAMPSITE:
            st.results = action.payload;
            if (
                isNil(
                    find(st.list, (c) => {
                        return c.campsite_id === action.payload.campsite_id;
                    })
                )
            ) {
                st.list = st.list.concat(action.payload);
            }
            // Please note that media col should come form the back-end.
            st.results.media = getMediaFromAttributes(st.results.attributes);
            delete st.err;
            return st;
        case GET_CAMPSITE_LIST:
            st.list = action.payload;
            delete st.listErr;
            return st;
        // finds the specific obj and updates the object and creats a new list.
        case CAMPSITE_CHANGE_STATUS: {
            const { campsiteId, status } = action.payload;
            const newList = [];
            for (let cs of st.list) {
                if (cs.campsite_id === campsiteId) {
                    const newCs = cloneDeep(cs);
                    newCs.campsite_status = status;
                    cs = newCs;
                }
                newList.push(cs);
            }
            st.list = newList;
            return st;
        }
        case GET_CAMPSITES:
            st.list = action.payload;
            return st;
        case GET_CAMPSITE_ERROR:
            st.err = action.err;
            return st;
        case GET_CAMPSITE_LIST_ERROR:
            st.listErr = action.error;
            return st;
        case GET_CAMPSITES_ERROR:
            st.err = action.err;
            return st;
        default:
            return st;
    }
}
